export function handleGoodsNum({ pre_sell, sales_sum }) {
  let sales = sales_sum;
  if (pre_sell) {
    const { act_count } = pre_sell;
    sales = act_count;
  }
  return `已${pre_sell ? '预订' : '售'}${sales}件`;
}

export function handleJavaGoodsNum({ preSellInfo, salesSum }) {
  let sales = salesSum;
  if (preSellInfo) {
    const { actCount } = preSellInfo;
    sales = actCount;
  }
  return `已${preSellInfo ? '预订' : '售'}${sales}件`;
}

export function handleGoodsPrice({
  pre_sell, shop_price, exchange_integral, exchange_price,
}) {
  if (pre_sell) {
    const { sale_price } = pre_sell;
    return `¥${sale_price}`;
  }
  if (exchange_integral) {
    if (Number(exchange_price)) {
      return `¥${exchange_price}+${exchange_integral}${this.coinName}`;
    }
    return `${exchange_integral}${this.coinName}`;
  }
  return `¥${shop_price}`;
}

export function handleJavaGoodsPrice({
  preSellInfo, shopPrice, exchangeIntegral, exchangePrice,
}) {
  if (preSellInfo) {
    const { salePrice } = preSellInfo;
    return `¥${salePrice}`;
  }
  if (exchangeIntegral) {
    if (Number(exchangePrice)) {
      return `¥${exchangePrice}+${exchangeIntegral}${this.coinName}`;
    }
    return `${exchangeIntegral}${this.coinName}`;
  }
  return `¥${shopPrice}`;
}
